import React from 'react';

const Footer = () => (
  <div id="footer">
    <p>© 2020 Kerron King. Made in T&amp;T.</p>
  </div>
);

export default Footer;
